import { render, staticRenderFns } from "./DoorContactDevicePanelAdapter.vue?vue&type=template&id=9477f0ec&lang=pug&"
import script from "./DoorContactDevicePanelAdapter.vue?vue&type=script&lang=ts&"
export * from "./DoorContactDevicePanelAdapter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports